module.exports = __webpack_public_path__ + "media/images/writer/monitor/pc-balloon-fde96bd8be18d1290cb3ed70675cda1a.png";